import { render, staticRenderFns } from "./GrupoDeZona.vue?vue&type=template&id=11c9e548&"
import script from "./GrupoDeZona.vue?vue&type=script&lang=ts&"
export * from "./GrupoDeZona.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('11c9e548', component.options)
    } else {
      api.reload('11c9e548', component.options)
    }
    module.hot.accept("./GrupoDeZona.vue?vue&type=template&id=11c9e548&", function () {
      api.rerender('11c9e548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/GrupoDeZona.vue"
export default component.exports